type ValidationResult<T> =
  | { isValid: true; error: null }
  | { isValid: false; error: T };

export enum CorralNameError {
  Required,
  Duplicated,
}

export function validateCorralName<T extends { id: number; name: string }>(
  name: string,
  corrals: T[],
  selectedCorralId: number | null
): ValidationResult<CorralNameError> {
  if (!name.trim()) {
    return { isValid: false, error: CorralNameError.Required };
  }

  const isDuplicate = corrals.some(
    (item) =>
      item.name.trim().toLowerCase() === name.trim().toLowerCase() &&
      item.id !== selectedCorralId
  );

  if (isDuplicate) {
    return { isValid: false, error: CorralNameError.Duplicated };
  }

  return { isValid: true, error: null };
}

export enum RetreatError {
  Required,
}

export function validateRetreatId(
  retreatId: number | null
): ValidationResult<RetreatError> {
  if (retreatId == null) {
    return { isValid: false, error: RetreatError.Required };
  }

  return { isValid: true, error: null };
}

export enum ShortNameError {
  Required,
}

export function validateShortName(
  shortName: string
): ValidationResult<ShortNameError> {
  if (!shortName.trim()) {
    return { isValid: false, error: ShortNameError.Required };
  }

  return { isValid: true, error: null };
}
